import { Workflow } from './workflow';

export class Document {
  id: number|undefined;
  active!: boolean;
  obligatoire!: boolean;
  code!: String;
  label!: String;
  description!: String;
  workflow!: Workflow;
}
